export const CUSTOMER_NUMBER_REGEX = '^[0-9]{7}$';
export const PIN_REGEX = '^[0-9a-zA-Z]{4}$';
// email regex taken from https://emailregex.com/ and additionally allow '_' in domain
export const EMAIL_REGEX =
  '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\_\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
export const PHONE_NUMBER_ALLOWED_CHARACTERS_REGEX = '^[0-9 +/-]*$';
export const TEXT_AREA_ALLOWED_CHARACTERS_REGEX = '^[a-zA-ZöÖäÄüÜß0-9?!=+&"\'*/%€@():,.-\\s]*$';
